/**
 * RegionTypeEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { RegionEntity } from "../RegionEntity";
import { RegionTypeEntity } from "../RegionTypeEntity";
declare global {
    interface EntityTypeMap {
        RegionType: RegionTypeEntity;
    }
}
export abstract class RegionTypeGeneratedEntity extends BaseEntity {
    public abstract regionTypeId: string;
    public abstract templateId: string | null;
    public abstract templateName: string | null;
    public abstract name: string;
    public abstract nameSystem: string;
    public abstract order: number | null;
    public abstract isDefault: boolean;
    public abstract nameComputed: string;
    public abstract project: ProjectEntity;
    public abstract readonly regions: ReadonlyArray<RegionEntity>;
}
